import { api, throwApiError } from "../../../api/api";

/**
 * Guia e comprovante dos recolhimentos de FGTS e INSS (ADR 0014): o arquivo sobe
 * pela rota `files` do recolhimento e sai só por `GET /dp/<recolhimento>/:id/file`.
 * A resposta do recolhimento traz só `hasGuide`/`hasReceipt` e o nome original.
 */
export type PaymentArea = "fgts-payments" | "inss-payments";
export type PaymentFileKind = "guide" | "receipt";

export type PaymentAttachments = {
  hasGuide?: boolean;
  hasReceipt?: boolean;
  guideFileName?: string | null;
  receiptFileName?: string | null;
};

/** Ausente = não mexe; `null` no assetId desvincula. */
export type PaymentAttachmentsPayload = {
  guideAssetId?: string | null;
  guideFileName?: string | null;
  receiptAssetId?: string | null;
  receiptFileName?: string | null;
};

const auth = (token: string) => {
  const raw = token?.startsWith("Bearer ") ? token.slice(7) : token;
  return { headers: { Authorization: `Bearer ${raw}` } };
};

export const uploadPaymentFileApi = async (token: string, area: PaymentArea, file: File): Promise<{ assetId: string; fileName: string | null }> => {
  const form = new FormData();
  form.append("file", file);
  try {
    const { data } = await api.post<{ assetId: string; fileName: string | null }>(`/dp/${area}/files`, form, {
      headers: { ...auth(token).headers, "Content-Type": "multipart/form-data" },
    });
    return data;
  } catch (error) {
    throwApiError(error, "Erro ao enviar o arquivo.");
    throw error;
  }
};

export const getPaymentFileBlobApi = async (token: string, area: PaymentArea, id: string, which: PaymentFileKind): Promise<Blob> => {
  try {
    const { data } = await api.get<Blob>(`/dp/${area}/${id}/file`, { ...auth(token), params: { which }, responseType: "blob" });
    return data;
  } catch (error) {
    throwApiError(error, which === "guide" ? "Erro ao abrir a guia." : "Erro ao abrir o comprovante.");
    throw error;
  }
};
